export const PAGE_LIMIT = 10;
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCT = "GET_PRODUCT";
export const URL="https://e-commerce-api-weld.vercel.app"
//export const URL = "https://insta-fashion-api.herokuapp.com";
//export const URL = "http://localhost:5000";
export const GET_CART = "GET_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const SET_TOTAL_PAGES = "SET_TOTAL_PAGES";
export const UPDATE_CART = "UPDATE_CART";
//"start": "react-scripts start",
//"start": "node server.js",